import { render } from "./VerificationCancelPopover.vue?vue&type=template&id=0451ccc2&scoped=true&ts=true"
import script from "./VerificationCancelPopover.vue?vue&type=script&lang=ts"
export * from "./VerificationCancelPopover.vue?vue&type=script&lang=ts"

import "./VerificationCancelPopover.vue?vue&type=style&index=0&id=0451ccc2&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0451ccc2"]])

export default __exports__